import { render, staticRenderFns } from "./RouteDataQualityView.vue?vue&type=template&id=62872bb0&scoped=true&"
import script from "./RouteDataQualityView.vue?vue&type=script&lang=js&"
export * from "./RouteDataQualityView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62872bb0",
  null
  
)

export default component.exports